// RenderTablesOptionC.jsx
import React from "react";
import tablecss from "../../css/table.module.css";

/**
 * Props:
 * - data: array of items (your payload)
 * - columnCount: total columns including the first "table-name" column (>=2 recommended)
 * - category: optional string to filter level-1 items by item.category
 *
 * Usage:
 * <RenderTablesOptionC data={myData} columnCount={3} category="BS" />
 */
export default function RenderBSPLTables({
  data,
  columnCount = 3,
  category = null,
  notesCount = 0,
}) {
  const cols = Math.max(1, Number(columnCount) || 3);
  // header will be: [ tableNameHeader, C1, C2, ... ] but tableNameHeader is the actual tableItem.name per row
  const cHeaders = Array.from({ length: cols - 1 }, (_, i) => `C${i + 1}`);

  // filter level-1 items and optionally by category
  const level1Items = Array.isArray(data)
    ? data.filter(
        (d) => d.level === 1 && (category == null || d.category === category)
      )
    : [];

  return (
    <>
      {level1Items.map((tableItem, ti) => (
        <div className={tablecss.tableContainer}>
          <table
            key={`tbl-${ti}-${tableItem.name}`}
            className={tablecss.customTable}
          >
            {/* HEADER: first column shows the actual table name for this table */}
            <thead>
              <tr style={{ textAlign: "left" }}>
                <th
                  style={{
                    padding: "10px 12px",
                    fontWeight: "bold",
                    backgroundColor: "#EFF7F0",
                    width:"300px"
                  }}
                >
                  {tableItem.name}
                </th>

                <th
                  className="text-center"
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#EFF7F0",
                  }}
                >
                  Notes
                </th>
                <th
                  className="text-center"
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#EFF7F0",
                  }}
                >
                  As on DD-MM-YYYY
                </th>
                <th
                  className="text-center"
                  style={{
                    padding: "10px 12px",
                    backgroundColor: "#EFF7F0",
                  }}
                >
                  As on DD-MM-YYYY
                </th>
              </tr>
            </thead>

            <tbody>
              {/* Level 2 rows */}
              {Array.isArray(tableItem.subgroup) &&
              tableItem.subgroup.length > 0 ? (
                tableItem.subgroup.map((l2, idx) => (
                  <React.Fragment key={`l2-${idx}-${l2.name}`}>
                    <tr>
                      <td>{l2.name}</td>
                      <td className="text-center">{notesCount + 1}</td>
                      <td className="text-center">-</td>
                      <td className="text-center">-</td>

                      {/* {cHeaders.map((_, i) => (
                        <td key={i} />
                      ))} */}
                    </tr>

                    {/* Level 3 rows (indented) */}
                    {/* {Array.isArray(l2.subgroup) &&
                      l2.subgroup.map((l3, j) => (
                        <tr key={`l3-${idx}-${j}-${l3.name}`}>
                          <td>&ensp;↳&nbsp; {l3.name}</td>

                          {cHeaders.map((_, i) => (
                            <td key={i} />
                          ))} 
                          <td className="text-center">{notesCount + 1}</td>
                          <td className="text-center">-</td>
                          <td className="text-center">-</td>
                        </tr>
                      ))} */}
                  </React.Fragment>
                ))
              ) : (
                // no subgroup rows
                <tr>
                  <td
                    style={{ padding: "10px 12px", color: "#6b7280" }}
                    colSpan={cols}
                  >
                    <em>No Level 2 or Level 3 items.</em>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ))}
    </>
  );
}
